import { createSelector } from '@reduxjs/toolkit';

export const alertDialogSliceName = 'alertDialog';

/* Selectors */
const selectAlertDialogState = state => state[alertDialogSliceName];

export const selectAlertDialogProps = createSelector(selectAlertDialogState, data => data);

export const selectAlertDialogAcceptHandler = createSelector(selectAlertDialogState, data => data.acceptHandler);
export const selectAlertDialogCancelHandler = createSelector(selectAlertDialogState, data => data.cancelHandler);
